export const TID = {
  // Auth
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  loginError: "login-error",
  demoAdmin: "demo-admin-btn",
  demoPro: "demo-pro-btn",
  demoClient: "demo-client-btn",
  demoPartner: "demo-partner-btn",
  signoutBtn: "signout-btn",

  // Shell
  sidebarToggle: "sidebar-toggle",
  aiPanelToggle: "ai-panel-toggle",
  companySwitcher: "company-switcher",
  companySwitcherOption: "company-switcher-option",
  navLink: "nav-link",
  navGroup: "nav-group",

  // Dashboard
  aiActivityCard: "ai-activity-card",
  aiPulseSection: "ai-pulse-section",

  // Transactions
  txnRow: "txn-row",
  txnBulkCheckbox: "txn-bulk-checkbox",
  txnRowCheckbox: "txn-row-checkbox",
  txnApprove: "txn-approve-btn",
  txnRecategorize: "txn-recategorize-btn",
  txnSplit: "txn-split-btn",
  txnLink: "txn-link-btn",
  txnEditCategory: "txn-edit-category",
  txnAddBtn: "txn-add-btn",
  txnFilterReview: "txn-filter-review",
  txnBulkApprove: "txn-bulk-approve",
  txnBulkCreateRules: "txn-bulk-create-rules",
  txnPageSize: "txn-page-size",
  txnPagePrev: "txn-page-prev",
  txnPageNext: "txn-page-next",
  txnPageIndicator: "txn-page-indicator",
  txnSearch: "txn-search",
  txnSearchClear: "txn-search-clear",
  txnDateFrom: "txn-date-from",
  txnDateTo: "txn-date-to",
  txnFiltersClear: "txn-filters-clear",
  syncPill: "sync-pill",
  firstConnectWelcome: "first-connect-welcome",
  firstConnectDismiss: "first-connect-dismiss",

  // Reports
  reportTile: "report-tile",
  reportBasisToggle: "report-basis-toggle",
  reportExportPdf: "report-export-pdf",
  reportApply: "report-apply-btn",

  // AI Chat
  aiChatInput: "ai-chat-input",
  aiChatSend: "ai-chat-send",
  aiChatMessage: "ai-chat-message",

  // Onboarding
  onboardingNext: "onboarding-next",
  onboardingBack: "onboarding-back",
  onboardingSkip: "onboarding-skip",
  onboardingMockPlaid: "onboarding-mock-plaid",
  onboardingMockVeryfi: "onboarding-mock-veryfi",
  onboardingCoaGenerate: "onboarding-coa-generate",
  onboardingComplete: "onboarding-complete",

  // Generic
  addBtn: "add-btn",
  saveBtn: "save-btn",
  cancelBtn: "cancel-btn",
  deleteBtn: "delete-btn",
  editBtn: "edit-btn",
};
